import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const FIND = () => {
  return (
    <CardSection id="FIND" title="FIND">
      <Paragraph>
        지정된 문자열을 검색하여 일치하는 문자열의 위치를 반환합니다. 찾을 수
        없으면 <span className="highlight">0</span> 값을 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>FIND(STRING_1, STRING_2, [VALUE])</Paragraph>
        <Ul>
          <Li>
            <b>STRING_1</b>은 찾으려는 문자열입니다.
          </Li>
          <Li>
            <b>STRING_2</b>는 검색의 대상이 되는 문자열입니다.
          </Li>
          <Li>
            <b>VALUE</b>는 선택 사항이며, <b>STRING_2</b>에서 검색을 시작할 숫자
            위치입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>FIND("Tech",`School`)</Paragraph>
        <Img src="computeFind" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열, 텍스트 문자열을 포함하는 열
          또는 텍스트 문자열을 반환하는 함수여야 합니다. 마찬가지로 <b>VALUE</b>
          는 숫자 값, 숫자 값을 포함하는 열 또는 숫자 값을 반환하는 함수여야
          합니다.
        </Paragraph>
        <Paragraph>
          <b>STRING_1</b>이 <b>STRING_2</b>에 여러 번 나타나는 경우 <b>FIND</b>
          는 쌍의 연속된 일치 항목이 아닌 첫 번째 일치 항목의 위치만 나타냅니다.
        </Paragraph>
        <Paragraph>
          <b>FIND</b>함수 는 대소문자를 구분하므로 True, TRUE, true를 별도로
          처리합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
